import type {ReactElement} from 'react';
import React from 'react';
import {GammaColorType} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-gamma-option/base-gamma-option.types';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {GAMMA_COLOR_EFFECT_MAX, GAMMA_COLOR_EFFECT_MIN} from '@PosterWhiteboard/items/image-item/gamma-effect.class';
import {
  GAMMA_COLOR_DISPLAY_MAX,
  GAMMA_COLOR_DISPLAY_MIN,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-gamma-option/item-gamma-option.types';

interface BaseGammaColorOptionProps {
  color: GammaColorType;
  value: number;
  updateColor(color: GammaColorType, value: number, undoable?: boolean): void;
  className?: string;
}

export function BaseGammaColorOption({className = '', ...props}: BaseGammaColorOptionProps): ReactElement<any> | null {
  const getLabel = (color: GammaColorType): string => {
    switch (color) {
      case GammaColorType.BLUE:
        return window.i18next.t('pmwjs_blue');
      case GammaColorType.GREEN:
        return window.i18next.t('pmwjs_green');
      case GammaColorType.RED:
        return window.i18next.t('pmwjs_red');
      default:
        throw new Error('Unhandled gamma color type');
    }
  };

  return (
    <ContextualMenuSliderOptions
      id={`item-gamma-${props.color}-option`}
      value={props.value}
      label={getLabel(props.color)}
      className={className}
      range={{min: GAMMA_COLOR_EFFECT_MIN, max: GAMMA_COLOR_EFFECT_MAX}}
      transformDisplay={{min: GAMMA_COLOR_DISPLAY_MIN, max: GAMMA_COLOR_DISPLAY_MAX}}
      onChange={(updatedValue: number): void => {
        props.updateColor(props.color, updatedValue, false);
      }}
      onChangeEnded={(updatedValue: number): void => {
        props.updateColor(props.color, updatedValue);
      }}
    />
  );
}
